import { BaseApi } from "../shared/api";
import * as types from "./actionTypes";
import * as url from "./apiUrls";

// replace this with an action creator
export function handleErrors(error) {
  return dispatch => {
    dispatch({type: types.HANDLE_ERRORS, payload: error})
  }
}

export function showErrors(errors) {
  return { type: types.HANDLE_ERRORS, payload: errors };
}

export function clearErrors(errors) {
  return { type: types.CLEAR_ERRORS };
}

export function startLoading(name = 'default') {
  return { type: types.LOADING_START, payload: name };
}

export function stopLoading(name = 'default') {
  return { type: types.LOADING_STOP, payload: name };
}

export function initModal(name = 'default', open = false) {
  return { type: types.MODAL_INIT, payload: { name, open } };
}

export function openModal(name = 'default') {
  return { type: types.MODAL_OPEN, payload: name };
}

export function closeModal(name = 'default') {
  return { type: types.MODAL_CLOSE, payload: name };
}

export function sessionExpire() {
  return { type: types.SESSION_EXPIRE };
}

export function notify(payload) {
  return { type: types.NOTIFY, payload: payload };
}

export function clearNotification() {
  return { type: types.CLEAR_NOTIFICATION };
}

export function notifyUpdate() {
  return { type: types.NOTIFY_UPDATE };
}

export function setSourceRoute(source) {
  return { type: types.SET_SOURCE_ROUTE, payload: source };
}

export function resetSourceRoute(source) {
  return { type: types.RESET_SOURCE_ROUTE };
}

export function fetchCompanyMonthlySelectOptions() {
  return (dispatch, getState) => {
    dispatch(startLoading);

    const api = new BaseApi(dispatch, getState);
    return api.getRequest(
      url.companyMonthlyIncome(),
      response => {
        dispatch(stopLoading());
        dispatch({
          type: types.COMPANY_MONTHLY_FETCH_SUCCESS,
          payload: response.data.data_point_options,
        })
      }
    )
  }
}

export function setUploadProgress(progress) {
  return { type: types.SET_UPLOAD_PROGRESS, payload: progress };
}

export function closeBanner(type='maintenance_banner') {
  return { type: types.CLOSE_BANNER, payload: type};
}

export function openBanner(type='maintenance_banner') {
  return { type: types.OPEN_BANNER, payload: type};
}



// WEBPACK FOOTER //
// ./src/features/shared/actions.js